<template>
    <a-card :bordered="false" class="header-solid h-full">
        <!-- Title -->
        <template #title>
            <a-row type="flex" justify="space-between" align="top">
                <a-col :span="20">
                    <h5 class="font-semibold m-0">AD Server Info</h5>
                </a-col>
            </a-row>
        </template>
        <!-- Body -->
        <a-table :columns="columns" :data-source="data" :pagination="false" rowKey="_id">
            <template slot="status" slot-scope="status">
                <a-tag v-if="status === 'Active'" color="green">{{status}}</a-tag>
                <a-tag v-if="status === 'Disable'" color="red">{{status}}</a-tag>
            </template>
        </a-table>
    </a-card>
</template>

<script>
import axios from 'axios';

export default ({
    props: {
        
    },
    components: {

    },
    data() {
        return {
            data: [],
            columns: [
                {
                    title: 'IP',
                    dataIndex: 'ip',
                    scopedSlots: { customRender: 'ip' },
                },
                {
                    title: 'BASE-DN',
                    dataIndex: 'basedn',
                    scopedSlots: { customRender: 'basedn' },
                },
                {
                    title: 'Status',
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                },
            ],
        }
    },
    //
    //
    //
    mounted() {
        this.data.push({
            _id: '1',
            ip: 'ldap://192.168.99.106',
            basedn: 'dc-acs,dc=local',
            status: 'Active',
        });
    },
    methods: {
        
    },
})
</script>

<style lang="scss">
</style>